export const calcPercentage = (totalSold: number, totalAvailable: number) => {
	if (totalAvailable === 0) return 0;
	else return (totalSold / totalAvailable) * 100;
};
